<template>
  <label v-if="label && showInput" :for="inputId" :class="['inp-label', {'a11y-blind': hideLabel}, labelClass]">
    {{ label }}
    <!-- <span v-if="required" class="input-required">*</span> -->
  </label>
  <!-- <div v-if="type === 'upload'" class="inp-button-wrap"> -->
  <div v-if="showInput" class="inp-button-wrap">
    <div class="inp-text-wrap file-upload calc106">
      <input
        v-model="uploadName"
        type="text"
        :class="['inp-text upload-name', inputClass]"
        :id="inputId"
        :name="inputId"
        :placeholder="placeholder"
        readonly />
      <input type="file" :id="inputId+'_1'" ref="input-file" class="upload-hidden"
        :accept="uploadToken && uploadToken.acceptTypes.join(',')" 
        @click="onClickFileUpload" @change="onFileChange" />
    </div>
    <label :for="inputId+'_1'" :class="['btn', 'upload-label', buttonClass]" v-if="showButton">{{ buttonText }}</label>
  </div>
  
</template>

<!-- 하단 onClickFileUpload 를 제외 하고 ComFileUpload와 완전 동일한 script -->
<script lang="ts">
// type InputType = 'text' | 'password' | 'number' | 'email' | 'business' | 'upload' | 'date' | 'tel' | 'message' | 'account';

interface FileUploadProps {
  tokenProvider: string;
  uiType?: 'default' | 'thumbnail';
  uploadableDesc?: string;
  disabled?: boolean | 'true' | 'false';
  // selectValidator?: (selectedFiles:File[]) => string | null | undefined;
  uploaded?: CommonFile[];
  additionalClass?: string;
  filesLimit?: string | number;
  
  // #########################################################
  
  labelClass?: string,
  label: string,
  hideLabel: boolean
  buttonClass: string,
  inputClass: string,
  showButton: boolean,
  buttonText: string,
  placeholder: string,
  chkAcceptType?: string[],
  showInput?: boolean

// #########################################################
}

interface UploadFileInfo {
  name: string;
  type: string;
  size: number;
}

interface UploadProgress {
  status: string;
  bytes: {
    total: number;
    current: number;
  },
  total: {
    size: string;
    cur: string;
    per: string;
  };
  files: {
    size: string;
    cur: string;
    per: string;
  }[];
}

</script>

<script lang="ts" setup>

// #########################################################

import { useId} from 'vue';
import { usePopup } from '@/composables/hconUsePopup'// 팝업
import { COMMON_CODE } from "@/constants/hconMessageConstants";

const { showAlert}  = usePopup()
const inputId = useId();
const uploadName = ref<string>('')
// const dialog                      = useHconDialog();
const config                      = useHconConfig();
const fetchBuilder                = useHconFetchBuilder();

// #########################################################

const props                       = withDefaults(defineProps<FileUploadProps>(), {autoUpload: true, disabled: false, showInput: true});
const isDisabled                  = computed(() => props.disabled == true || props.disabled == 'true');
const areaBorder                  = ref<string>();
const inputFile                   = useTemplateRef('input-file');
const uploadedFiles               = defineModel<CommonFile[]>({default: () => []});
const storedFiles                 = computed(() => uploadedFiles.value.filter(uf => uf.status == 'STORED'));
// const dialog                      = useEzwelDialog();
// const config                      = useEzwelConfig();
const progress                    = ref<UploadProgress>();
const sizeFormater                = new Intl.NumberFormat('ko-KR', {maximumFractionDigits:2, minimumFractionDigits:2});
const perFormater                 = new Intl.NumberFormat('ko-KR', {style: 'percent', maximumFractionDigits:0, minimumFractionDigits:0});
const uploadToken                 = ref<CommonFileUploadToken>();
// const fetchBuilder                = useEzwelFetchBuilder();
const emits                       = defineEmits(['update:modelValue', 'change', 'busy', 'upload-started']);
const isAddNewable                = ref(true);
let   curXhr:XMLHttpRequest|null  = null;
const fetchWhoami                 = fetchBuilder.get<any>('/mypage/api/v1/private/auth/whoami').build();
const fetchUploadToken            = fetchBuilder
    .get<CommonFileUploadToken>(props.tokenProvider)
    .transform(res => res.data)
    .build();
    
// const additionalClassStr          = props.additionalClass ?? '';
let   filesLimit                  = cu.toNumber(props.filesLimit) ?? -1;

watchEffect(() => {
  if (uploadToken.value !== undefined) {
    filesLimit  = uploadToken.value.filesLimit;
  }
  isAddNewable.value  = filesLimit == -1 || storedFiles.value.length < filesLimit;
})

if (uploadedFiles.value === undefined) {
  uploadedFiles.value = [];
}

if (props.uploaded) {
  uploadedFiles.value = props.uploaded
}

const toSizeText    = (size:number) => {
  if (size < 1024) {
    return size + 'Bytes';
  } else if (size < 1048576) {
    return sizeFormater.format(Math.floor(size / 1024)) + 'KB';
    // } else if (size < 1073741824) {
    //   return sizeFormater.format(size / 1048576) + 'MB';
  } else {
    return sizeFormater.format(size / 1048576) + 'MB';
    // return sizeFormater.format(size / 1073741824) + 'GB';
  }
}

const checkUploadtoken  = (ev: Event) => {
  if (!uploadToken.value) {
    fetchUploadToken.execute().then(token => {
      uploadToken.value = token;
      nextTick(() => {
        // if (inputFileLabel.value) {
        //   inputFileLabel.value.click();
        // }
        if (inputFile.value) {
          inputFile.value.click();
        }
      })
    });
    ev.preventDefault();
  } else if (uploadToken.value.filesLimit < uploadedFiles.value.length) {
    ev.preventDefault();
  }
}

const selectFile    = async (files?: FileList | null) => {

  if (files) {
    for (let i = 0; i < files.length; i++) {
      let isAccept  = false;
      const fileName  = files[i].name.toLowerCase();
      const fileType  = files[i].type.toLowerCase();

      if(props.chkAcceptType !== undefined && props.chkAcceptType.length > 0) {
        for (const acceptType of props.chkAcceptType.map(t => t.toLowerCase()) ) {
          if (fileName.endsWith(acceptType)) {
            isAccept  = true;
            break;
          }
        }
      } else {
        if(uploadToken.value != undefined) {
          for (const acceptType of uploadToken.value.acceptTypes.map(t => t.toLowerCase()) ) {
            if (fileName.endsWith(acceptType)) {
              isAccept  = true;
              break;
            } else if (fileType.match(new RegExp('^' + acceptType.replaceAll('*', '.+')  + '$', 'i')) !== null) {
              isAccept  = true;
              break;
            }
          }
        }
      }
      
      if (!isAccept) {
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9147, files[i].name),
          confirmText: '확인'
        })

        if (inputFile.value) {
          inputFile.value.value = '';
        }
        return;
      }
    }

    // if (props.selectValidator) {
    //   // const denyMessage = props.selectValidator([...files]);
    //   const denyMessage = props.selectValidator(Array.from(files)); // ([...files]);
    //   if (denyMessage) {
    //     showAlert({
    //       title: '알림',
    //       message: denyMessage,
    //       confirmText: '확인'
    //     })
    //     if (inputFile.value) {
    //       inputFile.value.value = '';
    //     }
    //     return;
    //   }
    // }

    const newSelected:File[]  = [];
    const toBigFiles:File[]   = [];
    for (let i=0; i<files.length; i++) {
      if (files[i].size > (uploadToken.value?.sizeLimitPerFile ?? 0)) {
        toBigFiles.push(files[i]);
      } else {
        const newFileName  = files[i].name;
        const newFileSize  = files[i].size;
        const asUploaded   = uploadedFiles.value.find(uploadedFile => uploadedFile.name == newFileName && uploadedFile.size == newFileSize);
        if (asUploaded !== undefined) {
          if (asUploaded.status == 'MARKDELETE' && asUploaded.store == 'TEMPORARY') {
            asUploaded.status = 'STORED';
          } else {
            newSelected.push(files[i]);
          }
        } else {
          newSelected.push(files[i]);
        }
      }
    }

    if (uploadedFiles.value.filter(uploadedFile => uploadedFile.status == 'STORED').length + newSelected.length > (uploadToken.value?.filesLimit ?? 0)) {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9148, `${uploadToken.value?.filesLimit}`),
        confirmText: '확인'
      })
      return
    }

    const doSelectAfter = () => {
      if (newSelected.length) {
        nextTick(() => upload(newSelected));
      }
    }

    if (toBigFiles.length == 0) {
      doSelectAfter();
    } else {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9149, props.chkAcceptType, `${toSizeText(uploadToken.value?.sizeLimitPerFile ?? 0)}`),
                                                    // , `${toSizeText(uploadToken.value?.sizeLimitPerFile ?? 0)}`
                                                    // , toBigFiles.reduce((msg, file) => msg + `${file.name} </br>파일크기: ${toSizeText(file.size)}`, '')),
        confirmText: '확인'
      })

      if (inputFile.value) {
          inputFile.value.value = ''
      }
      return
    }

    // //단건업로드만 고려
    // uploadName.value= files[0].name
  }
}

const upload        = (selectedFiles:File[]) => {
  if (selectedFiles.length == 0) {
    showAlert({
      title: '알림',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9150),
      confirmText: '확인'
    })
    return false;
  }
  if (uploadToken.value === undefined) {
    fetchUploadToken.execute().then(res => {
      uploadToken.value = res;
      upload(selectedFiles);
    });
    return true;
  }
  let authInfo        = useEzwelAuthInfo().getIfPossible();
  const uploadFileInfos:UploadFileInfo[]  = selectedFiles.map(file => ({name:file.name, type:file.type, size:file.size} as UploadFileInfo));
  const baseUrl       = config.api.baseUrl;
  const uploadSummary = new TextEncoder().encode(JSON.stringify(uploadFileInfos));
  const body          = new Blob([uploadSummary, Uint8Array.of(0, 0, 0), ...selectedFiles]);
  let   indexacu      = uploadSummary.length;
  const uploadIndexes = [indexacu];
  uploadFileInfos.map(info => {
    indexacu  += info.size;
    uploadIndexes.push(indexacu);
  });

  progress.value  = {
    status: '0%',
    bytes: {
      total: indexacu,
      current: 0,
    },
    total: {
      size: toSizeText(indexacu),
      cur: toSizeText(0),
      per: perFormater.format(0),
    },
    files: uploadFileInfos.map(info => ({
      size: toSizeText(info.size),
      cur: toSizeText(0),
      per: perFormater.format(0),
    }))
  }

  const refreshAndRetry = () => {
    if (authInfo) {
      // 토큰 만료시 whoami 호출하여 토큰 갱신 유도 후 재시도
      fetchWhoami.execute().then(res => {
        authInfo  = useEzwelAuthInfo().getIfPossible();
        if (authInfo) {
          xhr.setRequestHeader('Authorization', `Bearer ${authInfo.accessToken}`);
          xhr.send(body);
          authInfo = null; // 반복 재호출 방지
        }
      });
      return true;
    }
    return false;
  }

  const uploadComplete = (newUploaded:CommonFile[]) => {
    const errfiles  = newUploaded.filter(uploadedFiles => uploadedFiles.status != 'STORED');
    progress.value  = undefined;
    if (errfiles.length > 0) {
      if (errfiles.length != uploadedFiles.length) {
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9151
                                                    , errfiles.reduce((msg, file) => msg + `- ${file.name} : ${file.statusDetail}\n`, '')),
          confirmText: '확인'
        })
      } else {
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9152
                                                    , errfiles.reduce((msg, file) => msg + `- ${file.name} : ${file.statusDetail}\n`, '')),
          confirmText: '확인'
        })
      }
    }
    uploadedFiles.value = [...uploadedFiles.value, ...newUploaded];
    if (inputFile.value) {
      inputFile.value.value = '';
    }
    emits('change', uploadedFiles.value);
  }

  const xhr = new XMLHttpRequest();
  curXhr    = xhr;
  xhr.upload.addEventListener('progress', (ev:ProgressEvent) => {
    if (progress.value) {
      progress.value.bytes.current    = ev.loaded;
      progress.value.total.cur        = toSizeText(ev.loaded);
      progress.value.total.per        = perFormater.format(ev.loaded / indexacu);
      if (progress.value.total.per == '100%') {
        progress.value.status         = '등록중...';
      } else {
        progress.value.status         = progress.value.total.per;
      }
      for (let i=1; i<uploadIndexes.length; i++) {
        if (ev.loaded < uploadIndexes[i-1]) {
          continue;
        } else if (ev.loaded > uploadIndexes[i-1] && ev.loaded < uploadIndexes[i]) {
          const cur   = ev.loaded - uploadIndexes[i-1];
          progress.value.files[i-1].cur = toSizeText(cur);
          progress.value.files[i-1].per = perFormater.format(cur / uploadFileInfos[i-1].size);
        } else if (ev.loaded >= uploadIndexes[i]) {
          progress.value.files[i-1].cur = toSizeText(uploadFileInfos[i-1].size);
          progress.value.files[i-1].per = perFormater.format(1);
        }
      }
    }
  })

  xhr.onreadystatechange = (ev: Event) => {
    if (xhr.readyState == XMLHttpRequest.DONE) {
      curXhr  = null;
      if (xhr.status == 200) {
        try {
          const result  = JSON.parse(xhr.response);
          if (result.resultCode !== undefined) {
            if (result.resultCode == '200') {
              uploadComplete(result.data);
              return;
            } else if (result.resultCode == '401') {
              if (refreshAndRetry()) {
                return;
              }
              showAlert({
                title: '알림',
                message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9153),
                confirmText: '확인'
              })
            } else if (result.resultCode == '403') {
              showAlert({
                title: '알림',
                message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9154),
                confirmText: '확인'
              })
            } else {
              showAlert({
                title: '알림',
                message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9155, `${result.resultMessage}`),
                confirmText: '확인'
              })
              abort(true);
            }
            return;
          }
          showAlert({
            title: '알림',
            message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9156),
            confirmText: '확인'
          })
        } finally {
          uploadToken.value = undefined;
        }
      }
    }
  };
  xhr.onerror = (ev: Event) => {
    if (xhr.status == 401) {
      if (refreshAndRetry()) {
        return;
      }
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9153),
        confirmText: '확인'
      })
    } else {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9157),
        confirmText: '확인'
      })
    }
  }
  // xhr.open('POST', `${baseUrl}/customer/api/v1/common/files/${uploadToken.value.id}`, true);
  xhr.open('POST', `${baseUrl}/api/v1/common/files/${uploadToken.value.id}`, true);
  xhr.setRequestHeader('Content-Type', 'application/otect-stream');
  if (authInfo) {
    xhr.setRequestHeader('Authorization', `Bearer ${authInfo.accessToken}`);
  }
  xhr.send(body);
  return true;
}

const abort = (preventMessage?:boolean) => {
  if (curXhr != null) {
    curXhr.abort();
    curXhr          = null;
  } else if (!preventMessage) {
    showAlert({
      title: '알림',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9158),
      confirmText: '확인'
    })
    return false;
  }
  progress.value    = undefined;
  if (inputFile.value) {
    inputFile.value.value = '';
  }
  return true;
}

const removeFile = (fileId:string) => {
  const tfile = uploadedFiles.value.find(uploadedFile => uploadedFile.id == fileId);
  if (tfile) {
    if (tfile.store === 'TEMPORARY') {
      uploadedFiles.value = uploadedFiles.value.filter(uploadedFile => uploadedFile.id != fileId);
    } else {
      tfile.status = 'MARKDELETE';
    }
    isAddNewable.value  = true;
    emits('change', uploadedFiles.value);
  }
}

const dragoverFile  = (e:DragEvent) => {
  if (e.dataTransfer && e.dataTransfer.files && !isDisabled.value) {
    e.dataTransfer.effectAllowed    = 'copyMove';
    e.dataTransfer.dropEffect       = 'copy';
    areaBorder.value                = "solid 2px blue";
  } else {
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed    = 'none';
      e.dataTransfer.dropEffect       = 'none';
    }
  }
  e.preventDefault();
}

const dragleaveFile = (e:DragEvent) => {
  areaBorder.value  = undefined;
}

const dropFile  = (e:DragEvent) => {
  areaBorder.value  = undefined;
  if (e.dataTransfer && e.dataTransfer.files) {
    selectFile(e.dataTransfer.files);
  }

  e.preventDefault();
}

onBeforeUnmount(() => abort(true));
watch(progress, (newValue, oldValue) => {
  if (newValue && oldValue === undefined) {
    emits('busy', true);
  } else if (newValue === undefined && oldValue) {
    emits('busy', false);
  }
})

const onClickFileUpload = (e: Event)=> {
  e.stopPropagation();
  const file = storedFiles.value[0];
  if(file){
    removeFile(file.id);
  }
  checkUploadtoken(e);
}

const onFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  emits('upload-started', true);
  selectFile(target.files);
}
</script>

